import React from 'react';
import { string } from 'prop-types';

export default function Icon({ glyph, className = '' }) {
    return (
        <svg className={`svg-icon ${className}`}>
            <use xlinkHref={`#${glyph}`} />
        </svg>
    );
}

Icon.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    glyph: string.isRequired,
    className: string
    /* eslint-enable react/no-typos */
};

Icon.defaultProps = { className: '' };
